module.exports = __webpack_public_path__ + "static/img/dzzzLogo.0b00c593.png";